module.exports = __webpack_public_path__ + "img/ícone-buscar.94940c61.svg";